import { Button, Popover, Tag } from 'antd'
import React from 'react'
import { TagWrap } from '../AdminUserModal/UserInfoTabs/styles'
import EntryTime from './EntryTime'
import ActiveLog from './ActiveLog'
import { Text } from 'styles/reactnative'
import { useToken } from 'app/hooks'

const Contracts = ({ data, created_at = undefined }) => {
	const [load, setLoad] = React.useState(false)
	const { level } = useToken()

	return (
		<div
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '2px',
				justifyContent: 'center',
				alignItems: 'stretch',
				width: '100%',
				padding: '2px',
				position: 'relative'
			}}>
			{/* 활동 버튼 - 우측 상단 아이콘 */}
			{level == 99 && (
				<div style={{ 
					position: 'absolute', 
					top: '2px', 
					right: '4px',
					zIndex: 10
				}}>
					<Popover
						content={
							<>
								{load ? (
									<ActiveLog
										date={data?.created_at}
										userid={data?.user_id}
									/>
								) : (
									<Text>로딩중...</Text>
								)}
							</>
						}
						trigger={'click'}
						afterOpenChange={visible => {
							if (visible) {
								setLoad(true)
							} else {
								setLoad(false)
							}
						}}>
						<Button 
							type="primary" 
							shape="circle"
							size="small" 
							style={{ 
								width: '20px',
								height: '20px',
								padding: '0',
								fontSize: '10px',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center'
							}}
						>
							📊
						</Button>
					</Popover>
				</div>
			)}

			{/* 첫 번째 행: 주요 태그들 */}
			<div style={{ 
				display: 'flex', 
				flexWrap: 'wrap', 
				gap: '2px',
				justifyContent: 'flex-start',
				alignItems: 'center',
				minHeight: '20px',
				paddingLeft: '4px'
			}}>
				{data?.limit_market !== undefined && data?.limit_market !== null && (
					<span 
						style={{ 
							backgroundColor: data?.limit_market === 'M' ? '#1890ff' : '#f0f0f0',
							color: data?.limit_market === 'M' ? 'white' : '#666',
							padding: '2px 6px',
							borderRadius: '3px',
							fontSize: '10px',
							lineHeight: '16px',
							whiteSpace: 'nowrap',
							textAlign: 'center'
						}}>
						{data?.limit_market === 'M' ? '시장가' : '지정가'}
					</span>
				)}
				{data?.f !== undefined && data?.f !== null && data?.f !== 0 && (
					<span 
						style={{ 
							backgroundColor: '#ff4d4f',
							color: 'white',
							padding: '2px 6px',
							borderRadius: '3px',
							fontSize: '10px',
							lineHeight: '16px',
							whiteSpace: 'nowrap',
							textAlign: 'center'
						}}>
						{data?.f == 1
							? '로스컷'
							: data?.f == 3
							? '장마감'
							: data?.f == 5
							? 'MIT'
							: '오버부족'}
					</span>
				)}
				{data?.reduce_position !== undefined && data?.reduce_position !== null && data?.reduce_position !== 0 && (
					<span 
						style={{ 
							backgroundColor: '#d9d9d9',
							color: '#666',
							padding: '2px 6px',
							borderRadius: '3px',
							fontSize: '10px',
							lineHeight: '16px',
							whiteSpace: 'nowrap',
							textAlign: 'center'
						}}>
						종료주문
					</span>
				)}
			</div>

			{/* 두 번째 행: 시간 정보 */}
			{created_at !== undefined && created_at !== null && (
				<div style={{ fontSize: '9px', color: '#aaa', textAlign: 'center' }}>
					<EntryTime time={created_at} style={{ fontSize: '9px' }} />
				</div>
			)}
		</div>
	)
}

export default Contracts
